import datatable from "../../data/datatable.json"

const state = {
    items : datatable.items
};

export default {
    namespaced: true,
    state,
}
